export enum TaxBehaviorEnum {
  Inclusive = 'inclusive',
  Exclusive = 'exclusive',
}

export const taxBehaviorLocoKeys: Record<TaxBehaviorEnum, string> = {
  [TaxBehaviorEnum.Inclusive]: 'dashboard.payment.tax_behavior.inclusive',
  [TaxBehaviorEnum.Exclusive]: 'dashboard.payment.tax_behavior.exclusive',
}
